import { ISalesRepInfo } from "../models/epcCustomer.model";
import axiosSetup from "../utils/axiosSetup";

export const addSalesRepApi = async (salesRepData: ISalesRepInfo) => {
  try {
    const response = await axiosSetup.post(
      "salesRep/addSalesRep",
      salesRepData,
    );
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const getSalesRepBasedOnUser = async (
  search?: string,
  category?: string,
  page?: number,
  limit?: number,
) => {
  try {
    const response = await axiosSetup.get(`salesRep/fetchSalesRepBasedOnUser`, {
      params: { search, category, page, limit },
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};

export const getSingleSalesRepById = async (id: string) => {
  try {
    const response = await axiosSetup.post("salesRep/fetchSingleSalesRepById", {
      id,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};
export const updateSalesRepById = async (
  id: string,
  updatedData: Partial<ISalesRepInfo>,
) => {
  try {
    const response = await axiosSetup.patch("salesRep/updateSalesRepById", {
      id,
      ...updatedData,
    });
    return response.data.data;
  } catch (err: any) {
    throw err.response?.data?.message;
  }
};
